/**
 * Crea los botones para jugar
 * @param {*} scene
 */
export function crearBotones(scene) {
  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                     BOTONES FASE 1                                      ||
  ||                                    ARMADO DE APUESTA                                    ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /*/=======================================================================================\*\
  ||                               BOTON SUMAR                                               ||
  \*\=======================================================================================/*/

  scene.botonSumar = scene.add
    .image(498, 418, 'botonSumarEstatico')
    .setInteractive();
  scene.botonSumar.setVisible(true);

  scene.botonSumar.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonSumar.setTexture('botonSumarHover');
    }
  });

  scene.botonSumar.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonSumar.setTexture('botonSumarEstatico');
    }
  });

  scene.botonSumar.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonSumar.setTexture('botonSumarPressed');
    }
  });

  scene.botonSumar.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonSumar.input?.isOver) {
        scene.botonSumar.setTexture('botonSumarEstatico');
      } else {
        scene.botonSumar.setTexture('botonSumarHover');
        scene.sumarApuesta();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON RESTAR                                              ||
  \*\=======================================================================================/*/

  scene.botonRestar = scene.add
    .image(498, 470, 'botonRestarEstatico')
    .setInteractive();
  scene.botonRestar.setVisible(true);

  scene.botonRestar.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonRestar.setTexture('botonRestarHover');
    }
  });

  scene.botonRestar.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonRestar.setTexture('botonRestarEstatico');
    }
  });

  scene.botonRestar.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonRestar.setTexture('botonRestarPressed');
    }
  });

  scene.botonRestar.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonRestar.input?.isOver) {
        scene.botonRestar.setTexture('botonRestarEstatico');
      } else {
        scene.botonRestar.setTexture('botonRestarHover');
        scene.restarApuesta();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON BORRAR                                              ||
  \*\=======================================================================================/*/
  scene.botonBorrar = scene.add
    .image(698, 470, 'botonBorrarEstatico')
    .setInteractive();
  scene.botonBorrar.setVisible(true);

  scene.botonBorrar.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonBorrar.setTexture('botonBorrarHover');
    }
  });

  scene.botonBorrar.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonBorrar.setTexture('botonBorrarEstatico');
    }
  });

  scene.botonBorrar.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonBorrar.setTexture('botonBorrarPressed');
    }
  });

  scene.botonBorrar.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonBorrar.input?.isOver) {
        scene.botonBorrar.setTexture('botonBorrarEstatico');
      } else {
        scene.botonBorrar.setTexture('botonBorrarHover');
        scene.borrarApuesta();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON JUGAR                                               ||
  \*\=======================================================================================/*/
  scene.botonJugar = scene.add
    .image(898, 442, 'botonJugarEstatico')
    .setInteractive();
  scene.botonJugar.setVisible(true);

  scene.botonJugar.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonJugar.setTexture('botonJugarHover');
    }
  });

  scene.botonJugar.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonJugar.setTexture('botonJugarEstatico');
    }
  });

  scene.botonJugar.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonJugar.setTexture('botonJugarPressed');
    }
  });

  scene.botonJugar.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonJugar.input?.isOver) {
        scene.botonJugar.setTexture('botonJugarEstatico');
      } else {
        scene.botonJugar.setTexture('botonJugarHover');
        scene.jugarApuesta();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON REPETIR                                             ||
  \*\=======================================================================================/*/

  scene.botonRepetir = scene.add
    .image(698, 418, 'botonRepetirEstatico')
    .setInteractive();
  scene.botonRepetir.setVisible(true);

  scene.botonRepetir.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonRepetir.setTexture('botonRepetirHover');
    }
  });

  scene.botonRepetir.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonRepetir.setTexture('botonRepetirEstatico');
    }
  });

  scene.botonRepetir.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonRepetir.setTexture('botonRepetirPressed');
    }
  });

  scene.botonRepetir.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonRepetir.input?.isOver) {
        scene.botonRepetir.setTexture('botonRepetirEstatico');
      } else {
        scene.botonRepetir.setTexture('botonRepetirHover');
        scene.repetirApuesta();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                     BOTONES FASE 2                                      ||
  ||                                     DESICIONES MANO                                     ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /*/=======================================================================================\*\
  ||                               BOTON DIVIDIR MANO                                        ||
  \*\=======================================================================================/*/
  scene.botonDividirMano = scene.add
    .image(102, 444, 'botonDividirManoDesactivado')
    .setInteractive();
  scene.botonDividirMano.setVisible(false);

  scene.botonDividirMano.on('pointerover', () => {
    if (!scene.noVaMas && scene.puedeDividirMano) {
      scene.botonDividirMano.setTexture('botonDividirManoHover');
    }
  });

  scene.botonDividirMano.on('pointerout', () => {
    if (!scene.noVaMas && scene.puedeDividirMano) {
      scene.botonDividirMano.setTexture('botonDividirManoEstatico');
    }
  });

  scene.botonDividirMano.on('pointerdown', () => {
    if (!scene.noVaMas && scene.puedeDividirMano) {
      scene.botonDividirMano.setTexture('botonDividirManoPressed');
    }
  });

  scene.botonDividirMano.on('pointerup', () => {
    if (!scene.noVaMas && scene.puedeDividirMano) {
      if (scene.botonDividirMano.input?.isOver) {
        scene.botonDividirMano.setTexture('botonDividirManoEstatico');
      } else {
        scene.botonDividirMano.setTexture('botonDividirManoHover');
        scene.dividirMano();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON DOBLAR APUESTA                                      ||
  \*\=======================================================================================/*/
  scene.botonDoblarApuesta = scene.add
    .image(302, 444, 'botonDoblarApuestaDesactivado')
    .setInteractive();
  scene.botonDoblarApuesta.setVisible(false);

  scene.botonDoblarApuesta.on('pointerover', () => {
    if (!scene.noVaMas && scene.puedeDoblarApuesta) {
      scene.botonDoblarApuesta.setTexture('botonDoblarApuestaHover');
    }
  });

  scene.botonDoblarApuesta.on('pointerout', () => {
    if (!scene.noVaMas && scene.puedeDoblarApuesta) {
      scene.botonDoblarApuesta.setTexture('botonDoblarApuestaEstatico');
    }
  });

  scene.botonDoblarApuesta.on('pointerdown', () => {
    if (!scene.noVaMas && scene.puedeDoblarApuesta) {
      scene.botonDoblarApuesta.setTexture('botonDoblarApuestaPressed');
    }
  });

  scene.botonDoblarApuesta.on('pointerup', () => {
    if (!scene.noVaMas && scene.puedeDoblarApuesta) {
      if (scene.botonDoblarApuesta.input?.isOver) {
        scene.botonDoblarApuesta.setTexture('botonDoblarApuestaEstatico');
      } else {
        scene.botonDoblarApuesta.setTexture('botonDoblarApuestaHover');
        scene.doblarApuesta();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON PEDIR CARTA                                         ||
  \*\=======================================================================================/*/
  scene.botonPedirCarta = scene.add
    .image(502, 444, 'botonPedirCartaEstatico')
    .setInteractive();
  scene.botonPedirCarta.setVisible(false);

  scene.botonPedirCarta.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonPedirCarta.setTexture('botonPedirCartaHover');
    }
  });

  scene.botonPedirCarta.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonPedirCarta.setTexture('botonPedirCartaEstatico');
    }
  });

  scene.botonPedirCarta.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonPedirCarta.setTexture('botonPedirCartaPressed');
    }
  });

  scene.botonPedirCarta.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonPedirCarta.input?.isOver) {
        scene.botonPedirCarta.setTexture('botonPedirCartaEstatico');
      } else {
        scene.botonPedirCarta.setTexture('botonPedirCartaHover');
        scene.pedirCartaJugador();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON PLANTARME                                           ||
  \*\=======================================================================================/*/
  scene.botonPlantarme = scene.add
    .image(702, 444, 'botonPlantarmeEstatico')
    .setInteractive();
  scene.botonPlantarme.setVisible(false);

  scene.botonPlantarme.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonPlantarme.setTexture('botonPlantarmeHover');
    }
  });

  scene.botonPlantarme.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonPlantarme.setTexture('botonPlantarmeEstatico');
    }
  });

  scene.botonPlantarme.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonPlantarme.setTexture('botonPlantarmePressed');
    }
  });

  scene.botonPlantarme.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonPlantarme.input?.isOver) {
        scene.botonPlantarme.setTexture('botonPlantarmeEstatico');
      } else {
        scene.botonPlantarme.setTexture('botonPlantarmeHover');
        scene.plantarme();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                   BOTONES PRE FASE 2                                    ||
  ||                                    SEGURO BLACKJACK                                     ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /*/=======================================================================================\*\
  ||                               BOTON SI (SEGURO BLACKJACK)                               ||
  \*\=======================================================================================/*/
  scene.botonSiSeguro = scene.add
    .image(710, 420, 'botonSiSeguroEstatico')
    .setInteractive();
  scene.botonSiSeguro.setVisible(false);

  scene.botonSiSeguro.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonSiSeguro.setTexture('botonSiSeguroHover');
    }
  });

  scene.botonSiSeguro.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonSiSeguro.setTexture('botonSiSeguroEstatico');
    }
  });

  scene.botonSiSeguro.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonSiSeguro.setTexture('botonSiSeguroPressed');
    }
  });

  scene.botonSiSeguro.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonSiSeguro.input?.isOver) {
        scene.botonSiSeguro.setTexture('botonSiSeguroEstatico');
      } else {
        scene.botonSiSeguro.setTexture('botonSiSeguroHover');
        scene.aceptarSeguro();
      }
    }
  });

  /*/=======================================================================================\*\
  ||                               BOTON NO (SEGURO BLACKJACK)                               ||
  \*\=======================================================================================/*/
  scene.botonNoSeguro = scene.add
    .image(710, 472, 'botonNoSeguroEstatico')
    .setInteractive();
  scene.botonNoSeguro.setVisible(false);

  scene.botonNoSeguro.on('pointerover', () => {
    if (!scene.noVaMas) {
      scene.botonNoSeguro.setTexture('botonNoSeguroHover');
    }
  });

  scene.botonNoSeguro.on('pointerout', () => {
    if (!scene.noVaMas) {
      scene.botonNoSeguro.setTexture('botonNoSeguroEstatico');
    }
  });

  scene.botonNoSeguro.on('pointerdown', () => {
    if (!scene.noVaMas) {
      scene.botonNoSeguro.setTexture('botonNoSeguroPressed');
    }
  });

  scene.botonNoSeguro.on('pointerup', () => {
    if (!scene.noVaMas) {
      if (scene.botonNoSeguro.input?.isOver) {
        scene.botonNoSeguro.setTexture('botonNoSeguroEstatico');
      } else {
        scene.botonNoSeguro.setTexture('botonNoSeguroHover');
        scene.rechazarSeguro();
      }
    }
  });
}
